import { getApiUrl } from "../../../../service/network/UrlMapper"

const UHX_EVENT_SERVICE_BASE_URL = getApiUrl()["service_base_url"]
export const FORM_TEMPLATE_UPLOAD_URL = `${UHX_EVENT_SERVICE_BASE_URL}/event/api/v1/store/object/json/upload?bucketName=`
export const FORM_TEMPLATE_ADD = `${UHX_EVENT_SERVICE_BASE_URL}/formstreamapp/api/v1/formTemplate/add`
export const FORM_TEMPLATE_UPDATE = `${UHX_EVENT_SERVICE_BASE_URL}/formstreamapp/api/v1/formTemplate/update`
export const FORM_TEMPLATE_DELETE = `${UHX_EVENT_SERVICE_BASE_URL}/formstreamapp/api/v1/formTemplate/delete`
